import { AsyncPipe, NgClass } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MeetList } from '@athleticnet/athletic-live-api-models';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { filter, Observable, Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SiteConfigInterface } from '../../shared/models/config/site-config.interface';
import { MeetDatePipe } from '../../shared/pipes/meet-date.pipe';
import { IsDarkModeService } from '../../shared/services/is-dark-mode.service';
import { IsSidebarOpenService } from '../../shared/services/is-sidebar-open.service';
import { SiteConfigService } from '../../shared/services/site-config.service';
import { SidebarSearchComponent } from '../sidebar-search/sidebar-search.component';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  imports: [
    RouterLinkActive,
    RouterLink,
    FontAwesomeModule,
    RouterOutlet,
    SidebarSearchComponent,
    AsyncPipe,
    NgClass,
    MeetDatePipe,
  ],
})
export class SidebarComponent {
  @ViewChild('secondSideMenu') secondSideMenu!: ElementRef;
  @Input() meet!: MeetList;
  isSidebarOpenServiceSubscription!: Subscription;
  isDarkMode$!: Observable<boolean>;
  showSidebarSearch: boolean = true;
  routerSub!: Subscription;
  siteConfig$!: Observable<SiteConfigInterface | null>;
  protected readonly environment = environment;

  constructor(
    private router: Router,
    private isSidebarOpenService: IsSidebarOpenService,
    private isDarkModeService: IsDarkModeService,
    private siteConfigService: SiteConfigService,
  ) {
    this.isDarkMode$ = this.isDarkModeService.isDarkMode;
    this.siteConfig$ = this.siteConfigService.updateSiteConfig;
    this.isSidebarOpenServiceSubscription = this.isSidebarOpenService.isSidebarOpen.subscribe((isSidebarOpen) => {
      if (this.secondSideMenu) {
        if (isSidebarOpen) {
          this.secondSideMenu.nativeElement.classList.add('second-side-menu--open');
        } else {
          this.secondSideMenu.nativeElement.classList.remove('second-side-menu--open');
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.isSidebarOpenServiceSubscription) {
      this.isSidebarOpenServiceSubscription.unsubscribe();
    }
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  ngOnInit() {
    this.showSidebarSearch =
      this.router.url.includes('/follow') ||
      !(this.router.url.includes('/athletes') || this.router.url.includes('/teams'));
    this.routerSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.showSidebarSearch =
          event.url.includes('/follow') || !(event.url.includes('/athletes') || event.url.includes('/teams'));
      });
  }

  onDarkModeToggle() {
    this.isDarkModeService.toggleDarkMode();
  }
}
